import $fn from '@/utils/fn.ts';
import httpApi from '@/apis/httpApi'
import http from "@/utils/http.js"

// 获取员工列表
interface ListAdminData {
    token: string,
    account: string,
    page: number,
    pagenum: number,
}

export const listAdmin = (json: ListAdminData): any => http.httpPost({
    url: httpApi.staffPower.listAdmin,
    json,
})

// 添加员工
interface AddListAdminData {
    token: string,
    role_id: string,
    username: string,
    password: string,
    repassword: string,
    phone: string,
}

export const addListAdmin = (json: AddListAdminData): any => http.httpPost({
    url: httpApi.staffPower.addListAdmin,
    json,
})

// 编辑员工
export const editListAdmin = (json: AddListAdminData): any => http.httpPost({
    url: httpApi.staffPower.editListAdmin,
    json,
})

// 删除员工
interface DelListAdminData {
    token: string,
    id: string
}

export const delListAdmin = (json: DelListAdminData): any => http.httpPost({
    url: httpApi.staffPower.delListAdmin,
    json,
})


// 获取权限列表
interface PermissionListData {
    token: string,
}

export const permissionList = (json: PermissionListData): any => http.httpPost({
    url: httpApi.staffPower.permissionList,
    json,
})

// 获取角色列表
interface RoleListData {
    token: string,
}

export const roleList = (json: RoleListData): any => http.httpPost({
    url: httpApi.staffPower.roleList,
    json,
})

// 添加权限
interface RoleCreateData {
    token: string,
    name: string,
    permission: any,
}

export const roleCreate = (json: RoleCreateData): any => http.httpPost({
    url: httpApi.staffPower.roleCreate,
    json,
})

// 获取角色权限
interface RolePermissionData {
    token: string,
    role_id: string,
}

export const rolePermission = (json: RolePermissionData): any => http.httpPost({
    url: httpApi.staffPower.rolePermission,
    json,
})

// 修改角色权限
interface PermissionModifyData {
    token: string,
    role_id: string,
    permission: any
}

export const permissionModify = (json: PermissionModifyData): any => http.httpPost({
    url: httpApi.staffPower.permissionModify,
    json,
})

// 修改角色名称
interface RoleUploadData {
    admin_role_id: string,
    name: string
}

export const roleUpload = (json: RoleUploadData): any => http.httpPost({
    url: httpApi.staffPower.roleUpload,
    json,
})

// 删除角色
interface RoleDelRoleData {
    role_id: string
}

export const roleDelRole = (json: RoleDelRoleData): any => http.httpPost({
    url: httpApi.staffPower.roleDelRole,
    json,
})
